import React from "react";
import { connect } from "react-redux";
import {
  userSignOut,
  userSignIn,
  recoverPassword,
  userFacebookSignIn,
  userAppleSignIn,
  userGoogleSignIn,
  userSignUp,
} from "actions/Auth";

import "antd/dist/antd.css";
import "./style.css";
import "ant-design-pro/dist/ant-design-pro.css";

import { Row, Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined, GoogleOutlined } from "@ant-design/icons";
import firebase from "firebase";
import { cleanCacheInLogout } from "../../firebase/firebase";
import GeneralApi from "../../app/generalApi";
import { ensureCheckoutProfile } from "../../app/checkout";

const generalApi = new GeneralApi();

class UserInfo extends React.Component {
  state = {
    userInfo: null,
    isSubscribed: false,
    showModal: false,
    loading: true,
    forceBlackButtons: this.props.forceBlackButtons || false,
    visible: this.props.visible,
    darkBg: this.props.darkBg,
    poster: "",
    uid: "",
    email: "",
    password: "",
    nickname: "",
  };

  componentDidMount() {
    this.getUserInfo();
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.stopAuth) this.stopAuth();
  }

  isLogged = () => this.state.userInfo !== null;

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  goRegister = () => {
    if (this.props.navigateTo) this.props.navigateTo();
  };

  rememberPassword = () => {
    const email = prompt(
      "Introduce tu email, si la cuenta existe, te enviaremos instrucciones para crear tu nueva contraseña",
      ""
    );
    if (email) this.props.recoverPassword(email);
  };

  async savePersonalData(userData) {
    try {
      const user = {
        city: userData.city || "",
        name: userData.nickname || "",
        province: userData.province || "",
        country: userData.country || "",
        email: userData.email || "",
        phone: userData.phone || "",
        uid: userData.uid,
        photo: this.state.poster,
      };
      await generalApi.updateAccount(user);
      await generalApi.updateFacturacionUser(user);
      return true;
    } catch (error) {
      return false;
    }
  }

  async getUserInfo() {
    this.setState({ loading: true });
    let generation = 0;
    this.stopAuth = firebase.auth().onAuthStateChanged(async user => {
      const version = ++generation;
      const current = () => !this.unmounted && version === generation;
      const notify = data => {
        if (!current()) return;
        this.setState({ userInfo: data, isSubscribed: !!(data && data.isSubscribed), loading: false });
        if (this.props.checkUser) this.props.checkUser(data);
      };
      if (!user || user.isAnonymous) { notify(null); return; }
      const basic = { uid: user.uid, email: user.email || "", name: user.displayName || "", logged: true };
      try {
        const profile = await ensureCheckoutProfile(user);
        if (!current()) return;
        if (!profile) { notify(basic); return; }
        const subscription = await generalApi.checkIsSubscribed(profile.email);
        if (!current()) return;
        notify({ ...profile, logged: true, subscription, isSubscribed: subscription === true || subscription === "vip" });
      } catch (error) {
        notify(basic);
      }
    }, () => {
      if (!this.unmounted) {
        this.setState({ loading: false, userInfo: null, isSubscribed: false });
        if (this.props.checkUser) this.props.checkUser(null);
      }
    });
  }

  logOut = () => {
    this.props.userSignOut();
    sessionStorage.clear();
  };

  getSignButton(userInfo) {
    const { loading, forceBlackButtons, darkBg } = this.state;

    const onFinish = (values) => {
      this.props.userSignIn({
        email: values.username,
        password: values.password,
      });
    };

    if (loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <h3 style={{ color: "#ffffff" }}>Cargando...</h3>
        </div>
      );
    }

    if (!this.isLogged()) {
      return (
        <Row justify="center">
          <Form
            name="normal_login"
            className="login-form"
            size="small"
            onFinish={onFinish}
          >
            <Form.Item>
              <Button
                type="primary"
                style={{ backgroundColor: forceBlackButtons ? "#000" : "" }}
                className={generalApi.getButtonsStyle()}
                onClick={this.goRegister}
              >
                Suscríbete
              </Button>
            </Form.Item>
            <Form.Item
              name="username"
              rules={[
                { required: true, message: "Por favor, escribe tu usuario o email" },
              ]}
            >
              <Input prefix={<UserOutlined />} placeholder="Usuario o email" autoComplete="username" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Por favor, escribe tu contraseña" },
              ]}
            >
              <Input
                prefix={<LockOutlined />}
                type="password"
                placeholder="Contraseña"
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ backgroundColor: forceBlackButtons ? "#000" : "" }}
                className={generalApi.getButtonsStyle()}
              >
                Acceder
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                icon={<GoogleOutlined />}
                type="default"
                style={{ width: "100%" }}
                onClick={this.props.userGoogleSignIn}
              >
                Iniciar sesión con Google
              </Button>
            </Form.Item>

            <Form.Item>
              <Button
                type="link"
                style={{ color: darkBg ? "#fff" : "#000" }}
                onClick={this.rememberPassword}
              >
                No recuerdo la contraseña
              </Button>
            </Form.Item>
          </Form>
        </Row>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <h3 style={{ color: "#ffffff" }}>Bienvenid@ de nuevo</h3>
          <h3 style={{ color: "#ffffff" }}>{userInfo.name}</h3>
          <p style={{ color: "#ffffff", fontSize: 12, wordBreak: "break-word" }}>{userInfo.email}</p>
          <br />
          <Button
            type="primary"
            onClick={this.logOut}
            className={generalApi.getButtonsStyle()}
          >
            Cerrar sesión
          </Button>
        </div>
      );
    }
  }

  render() {
    const { userInfo, visible } = this.state;
    return (
      <div style={{ textAlign: "center" }}>
        {visible && this.getSignButton(userInfo)}
      </div>
    );
  }
}

export default connect(null, {
  userSignOut,
  userSignIn,
  recoverPassword,
  userFacebookSignIn,
  userAppleSignIn,
  userGoogleSignIn,
  userSignUp,
})(UserInfo);



// WEBPACK FOOTER //
// ./components/UserInfo/index.js